import { useState, useEffect } from 'react';
import type { Category } from '@/types';
import { getCategories } from '@/lib/api';

interface CategoryListProps {
  selectedCategory?: string;
  onCategorySelect: (category: string | undefined) => void;
}

export function CategoryList({
  selectedCategory,
  onCategorySelect,
}: CategoryListProps) {
  const [categories, setCategories] = useState<Category[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function loadCategories() {
      try {
        const response = await getCategories();
        if (response.success && response.feeds) {
          setCategories(response.feeds);
        }
      } catch (error) {
        console.error('Failed to load categories:', error);
      } finally {
        setIsLoading(false);
      }
    }

    loadCategories();
  }, []);

  if (isLoading) {
    return (
      <div className="flex gap-2 overflow-x-auto pb-2">
        {Array.from({ length: 8 }).map((_, i) => (
          <div
            key={i}
            className="h-8 w-24 rounded-full bg-white/5 animate-pulse flex-shrink-0"
          />
        ))}
      </div>
    );
  }

  if (categories.length === 0) {
    return null;
  }

  return (
    <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
      <button
        onClick={() => onCategorySelect(undefined)}
        className={`tag flex-shrink-0 transition-colors ${
          !selectedCategory
            ? 'bg-primary text-white'
            : 'hover:bg-white/20'
        }`}
      >
        All
      </button>
      {categories.slice(0, 15).map((category) => (
        <button
          key={category.id}
          onClick={() => onCategorySelect(category.name)}
          className={`tag flex-shrink-0 transition-colors ${
            selectedCategory === category.name
              ? 'bg-primary text-white'
              : 'hover:bg-white/20'
          }`}
        >
          {category.name}
        </button>
      ))}
    </div>
  );
}
